import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

const CategoryEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>()

  return (
    <div className='p-6'>
      
    </div>
  );
};

export default CategoryEdit;
